import { Column } from "../../../../core/components/Column";
import guiaInvitadosData from "../../../../core/data/db_guia_invitados.json";
import { TextComponent } from "../../../../core/components/TextComponent";
import { Row } from "../../../../core/components/Row";
import { SectionCard } from "../../../../core/components/SectionCard";
import { Ref } from "../../../../core/components/Ref";
import { urlBySinthiaFlores } from "../../../../core/constants/utils";

export const HomeScreen: React.FC = () => {
	const sections = Object.values(guiaInvitadosData.guia_para_invitados);

	return (
		<>
			<Row
				className="gap-0.5 sm:gap-4 max-sm:flex-col py-4 sm:py-8 bg-lightPurple w-full px-4"
				crossAxisAlignment="center"
				mainAxisAlignment="center"
			>
				<TextComponent
					variant="h1"
					className="uppercase font-bold text-darkPurple text-center"
				>
					Guía para <span className="text-secondaryPurple">Invitados</span>
				</TextComponent>
				<div className="max-sm:hidden w-[1px] h-6 bg-darkPurple" />
				<TextComponent
					variant="h4"
					className="text-darkPurple"
				>
					Megabodas -{" "}
					<a
						href={urlBySinthiaFlores}
						target="_blank"
						rel="noreferrer"
						className="underline text-secondaryPurple"
					>
						by Sinthia Flores
					</a>
				</TextComponent>
			</Row>
			<main className="self-center w-full sm:w-[40rem] xl:w-[60rem] mb-4 sm:mb-8">
				<Row
					className="py-4 sm:py-8 gap-8 px-5 max-sm:flex-col"
					mainAxisAlignment="center"
					crossAxisAlignment="center"
				>
					<img
						src="/principal.jpg"
						className="w-full sm:w-80 select-none aspect-square"
						draggable={false}
						alt="Persona indicando lugares para que los invitados puedan guiarse"
					/>
					<TextComponent
						variant="h6"
						className="max-sm:hidden text-gray-700"
					>
						Queremos que disfrutes al máximo esta <span className="text-darkPurple font-semibold">celebración</span>, por eso preparamos esta guía con las mejores{" "}
						<span className="text-darkPurple font-semibold">recomendaciones</span>. Aquí encontrarás <span className="text-darkPurple font-semibold">estilistas</span>,{" "}
						<span className="text-darkPurple font-semibold">restaurantes</span>, <span className="text-darkPurple font-semibold">cafés</span>,{" "}
						<span className="text-darkPurple font-semibold">discotecas</span>, <span className="text-darkPurple font-semibold">hoteles</span> y{" "}
						<span className="text-darkPurple font-semibold">lugares turísticos</span> para que tu <span className="text-darkPurple font-semibold">estadía</span> sea inolvidable.
						<br />
						<br />
						Desde opciones <span className="text-darkPurple font-semibold">gastronómicas</span> hasta experiencias de <span className="text-darkPurple font-semibold">aventura</span>,
						descubre todo lo que necesitas para aprovechar al máximo tu visita.
						<br />
						<br />
						<span className="text-darkPurple font-semibold">¡Explora, disfruta y vive cada momento!</span>
					</TextComponent>

					<TextComponent
						variant="h6"
						className="sm:hidden text-gray-600"
					>
						Queremos que disfrutes al máximo tu <span className="text-darkPurple font-semibold">estadía</span>, por eso preparamos esta guía con las mejores{" "}
						<span className="text-darkPurple font-semibold">recomendaciones</span>. Encuentra todo lo que necesitas para aprovechar al máximo tu visita.
						<br />
						<br />
						<span className="text-darkPurple font-semibold">¡Explora, disfruta y vive cada momento!</span>
					</TextComponent>
				</Row>
				<Column
					crossAxisAlignment="center"
					className="bg-white py-5 px-5 gap-5 min-h-screen"
				>
					<Column className="grid grid-cols-1 sm:grid-cols-2 w-full gap-4 sm:gap-8">
						{sections.map((section, index) => (
							<SectionCard
								key={index}
								index={index}
								img={section.img}
								titulo={section.titulo}
								descripcion={section.descripcion}
							>
								<Ref
									href={section.url}
									className="w-fit self-end font-bold mt-auto"
									size="sm"
									color="mutedViolet"
									secondary
								>
									<TextComponent variant="h7">Ver más</TextComponent>
								</Ref>
							</SectionCard>
						))}
					</Column>
				</Column>
			</main>
		</>
	);
};
